import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import { Box } from '@cmpsr/components';
import useDashboardBodyController from './dashboard-body.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import ComponentActionItem from './components/component-action-item-card';
import Top3Risks from './components/top-3-risks/top-3-risks';
import TestingPlan from './components/testing-plan/testing-plan';
import RecommendedActions from './components/recommended-actions/recommended-actions';
import RiskFactors from './components/risk-factors/risk-factors';
import { BiomarkerSummaryCard } from './components/biomarker-summary-card/biomarker-summary-card';
import { CriticalLabNotificationBanner } from '../../../notifications';

export default function DashboardBody({ children }: { children: React.ReactNode }) {
  const {
    riskScoresData,
    testSuggestionData,
    recommendedActionsData,
    hasCompleteLabResults,
    biomarkerCounts,
    notifications,
    isDismissingNotification,
    handleViewResults,
    handleDismissNotification,
  } = useDashboardBodyController();

  return (
    <>
      {/* Critical Lab Notifications */}
      {notifications.length > 0 && (
        <CriticalLabNotificationBanner
          notification={notifications[0]}
          onViewResults={() => handleViewResults(notifications[0].notificationId)}
          onDismiss={() => handleDismissNotification(notifications[0].notificationId)}
          isLoading={isDismissingNotification}
        />
      )}

      <DashboardLayout>
        <DashboardGrid>
          <Box as="main" w="100%">
            <ComponentActionItem>
              <Top3Risks risks={riskScoresData} />
            </ComponentActionItem>
          {hasCompleteLabResults && (
            <ComponentActionItem>
              <BiomarkerSummaryCard
                optimalCount={biomarkerCounts.optimal}
                normalCount={biomarkerCounts.normal}
                outOfRangeCount={biomarkerCounts.outOfRange}
              />
            </ComponentActionItem>
          )}
          <ComponentActionItem>
            <RiskFactors />
          </ComponentActionItem>
          <ComponentActionItem>
            <TestingPlan testSuggestions={testSuggestionData} />
          </ComponentActionItem>
          <ComponentActionItem>
            <RecommendedActions recommendedActions={recommendedActionsData} />
          </ComponentActionItem>
        </Box>
        <Box as="aside" minW="full">
          {children}
        </Box>
      </DashboardGrid>
    </DashboardLayout>
    </>
  );
}
